<ng-container *ngIf="course.supplementary_materials && course.supplementary_materials.length > 0">
  <ng-container *ngIf="layout == 'card'">
    <div class="card mb-2">
      <div class="card-body p-1">
        <h6 class="card-title mb-1">Course Materials</h6>
        <ng-container *ngIf="course.supplementary_materials && course.supplementary_materials.length > 0; else noSupplementaries">
          <a class="d-block" target="_blank" *ngFor="let supplementary of course.supplementary_materials"
            href="{{supplementary.uri}}">{{supplementary.title}}</a>
        </ng-container>
        <ng-template #noSupplementaries>No supplementary materials are available for this course.</ng-template>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="layout == 'inline'">
    <a name="supplementary-materials"></a>
    <h6>Course Materials</h6>
    <ul>
      <li *ngFor="let supplementary of course.supplementary_materials">
        <a target="_blank" href="{{supplementary.uri}}">{{supplementary.title}}</a>
      </li>
    </ul>
  </ng-container>
</ng-container>